import { triangleBaseSize, minSpaceBetweenOriginAndContainer } from './constants';
import { isInViewport } from './utils';
import { Direction } from './tooltip.type';
/**
 * Calculate space left to show the tooltip content on the specified direction.
 */
var calculateSpaceLeft = function (_a) {
    var originBounds = _a.originBounds, messageBounds = _a.messageBounds, containerBounds = _a.containerBounds, preferredDirection = _a.preferredDirection;
    var spaceNeeded = messageBounds.height + triangleBaseSize;
    var maxOffset = Math.min(containerBounds.height, window.innerHeight);
    var minOffset = Math.max(containerBounds.top, 0);
    return preferredDirection === Direction.down
        ? maxOffset - originBounds.bottom - spaceNeeded
        : originBounds.top - minOffset - spaceNeeded;
};
/**
 * Detect container/viewport borders and calculate in which direction a tooltip should open.
 */
export var getRecommendedDirection = function (_a) {
    var messageBounds = _a.messageBounds, originBounds = _a.originBounds, containerBounds = _a.containerBounds, preferredDirection = _a.preferredDirection;
    // Do not calculate a direction if the tooltip is not in the viewport
    if (!isInViewport(originBounds)) {
        return preferredDirection;
    }
    var recommendedDirection = [
        preferredDirection,
        preferredDirection === Direction.down ? Direction.up : Direction.down
    ]
        .find(function (direction) { return calculateSpaceLeft({
        containerBounds: containerBounds,
        messageBounds: messageBounds,
        originBounds: originBounds,
        preferredDirection: direction
    }) > 0; });
    return recommendedDirection || preferredDirection;
};
/**
 * Calculate number of pixels left between origin and container or window.
 */
export var getSpaceLeft = function (_a) {
    var originBounds = _a.originBounds, containerBounds = _a.containerBounds;
    return originBounds.left - Math.max(containerBounds.left, 0);
};
/**
 * Calculate number of pixels right between origin and container or window.
 */
export var getSpaceRight = function (_a) {
    var originBounds = _a.originBounds, containerBounds = _a.containerBounds;
    return Math.min(containerBounds.right, window.innerWidth) - originBounds.right;
};
/**
 * Calculate how many pixel we should shift the message and triangle so they can fit in the container.
 * It returns a css transform string to apply to the message and the left offset of the triangle.
 */
export var calculateMessageShift = function (_a) {
    var containerBounds = _a.containerBounds, originBounds = _a.originBounds;
    var diffLeft = getSpaceLeft({ originBounds: originBounds, containerBounds: containerBounds });
    var diffRight = getSpaceRight({ originBounds: originBounds, containerBounds: containerBounds });
    if (diffLeft < minSpaceBetweenOriginAndContainer) {
        return minSpaceBetweenOriginAndContainer - diffLeft;
    }
    return diffRight < minSpaceBetweenOriginAndContainer
        ? -minSpaceBetweenOriginAndContainer + diffRight
        : 0;
};
